module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/coat-hook/coat-hook.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/coat-hook/coat-hook.png
// module id = 540
// module chunks = 0